import { IStairConfig, IStepGeometry, IStringerGeometry, IVec3 } from '@stair-craft/common/util';

import { STRINGER_THICKNESS, STRINGER_WIDTH } from '../../constants';
import { kosourTopLine, riserSeatOf } from '../shared-kosour-top-line/kosour-top-line';

// Косоур — side beam with sawtooth top profile (steps sit on top of the notches).
// The cut line runs a tread thickness under the tread tops: floor → up to step 0's tread bottom
// at its riser line → along under step 0 → up at step 1's riser line → ... → under the last tread
// to the slab edge. Every tread bottom lies flat on the board; the riser stands behind each rise.
export function generateKosourStringer(
    steps: IStepGeometry[],
    config: IStairConfig,
    riserHeight: number,
    side: 'left' | 'right'
): IStringerGeometry {
    const xPos: number = side === 'left' ? 0 : config.stairWidth;
    const maxY: number = config.floorHeight + config.floorThickness;
    const profile: IVec3[] = [{ x: xPos, y: 0, z: 0 }];
    for (const step of steps) {
        profile.push({ x: xPos, y: step.position.y, z: step.position.z });
        profile.push({ x: xPos, y: step.position.y, z: step.position.z + step.treadDepth });
    }

    const lastStep: IStepGeometry = steps[steps.length - 1];
    const topZ: number = lastStep.position.z + lastStep.treadDepth;
    profile.push({ x: xPos, y: maxY, z: topZ });

    return {
        side,
        points: kosourTopLine(profile, config.treadThickness, true, riserSeatOf(config)),
        thickness: STRINGER_THICKNESS,
        width: STRINGER_WIDTH,
        bottomSlope: { rise: riserHeight, run: lastStep.treadDepth },
    };
}
